import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import '../../styles/main.css';
import { isServiceVendor } from '../../lib/tools';
import ColorSF2 from '../../styles/common/ColorSF2';

const style = {
  main: {
    minHeight: 46,
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: ColorSF2.paleBlue,
    color: ColorSF2.steelGray,
    fontSize: 14,
    padding: '0 10px',
    margin: '2px 0',
  },
  box1: {
    flex: '0 1 auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  item: {
    display: 'flex',
  },
  box2: {},
  box3: {},
  input: {
    width: 160,
  },
  select: {
    height: 24,
    marginLeft: 30,
  },
  defaultCheckBox: {
    display: 'none',
  },
  checkboxArea: {
    minWidth: 160,
    marginRight: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  checkboxLabel: {
    width: 20,
    height: 20,
    marginRight: 5,
  },
};

const selectCompanyType = types =>
  types.map(_item => (
    <option value={_item} key={`select_${_item}`}>
      {_item}
    </option>
  ));

const CompanySearchBox = ({
  role,
  searchOptions,
  companyTypes,
  onSearch,
  onChange,
  checkedLicenseOver,
  licenseCapacityStatus,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const defaultOption = formatMessage({
    id: 'company.searchOption.select.companyType.default',
  });
  const codePlaceholder = formatMessage({
    id: 'company.searchOption.input.companyCode.placeholder',
  });
  const namePlaceholder = formatMessage({
    id: 'company.searchOption.input.companyName.placeholder',
  });
  const companyTypeDefault =
    (searchOptions.companyTypes.length > 0 && searchOptions.companyTypes[0]) ||
    '';
  const displayLicenseOver =
    licenseCapacityStatus.userLicense ||
    licenseCapacityStatus.storageLicense ||
    licenseCapacityStatus.remoteSupportLicense;
  return (
    <div style={style.main} id="CompanyPageSearchBox">
      {displayLicenseOver && (
        <div style={style.box3}>
          <div style={style.checkboxArea}>
            <input
              id="checkLicenseOver"
              style={style.defaultCheckBox}
              type="checkbox"
              onClick={e => onChange(e.target.checked)}
              defaultChecked={checkedLicenseOver}
            />
            <label
              className="checkBoxLabel"
              style={style.checkboxLabel}
              htmlFor="checkLicenseOver"
            />
            <FormattedMessage id="company.searchOption.checkbox.title.licenseOver" />
          </div>
        </div>
      )}
      <div style={style.box1}>
        <div style={style.item}>
          <FormattedMessage id="company.searchOption.title.companyCode" />
          <input
            id="companySearchBoxInput1"
            style={style.input}
            type="text"
            value={searchOptions.companyCode}
            placeholder={codePlaceholder}
            onChange={e => onSearch({ companyCode: e.target.value })}
          />
        </div>
        <div style={style.item}>
          <FormattedMessage id="company.searchOption.title.companyName" />
          <input
            id="companySearchBoxInput2"
            style={style.input}
            type="text"
            value={searchOptions.companyName}
            placeholder={namePlaceholder}
            onChange={e => onSearch({ companyName: e.target.value })}
          />
        </div>
      </div>
      {isServiceVendor(role) && (
        <div style={style.box2}>
          <select
            id="selectCompany1"
            style={style.select}
            value={companyTypeDefault}
            onChange={e => {
              const value = (e.target.value && [e.target.value]) || [];
              onSearch({ companyTypes: value });
            }}
          >
            <option key="default" value="">
              {defaultOption}
            </option>
            {selectCompanyType(companyTypes)}
          </select>
        </div>
      )}
    </div>
  );
};

CompanySearchBox.propTypes = {
  role: PropTypes.number.isRequired,
  searchOptions: PropTypes.object.isRequired,
  companyTypes: PropTypes.array.isRequired,
  onSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  checkedLicenseOver: PropTypes.bool.isRequired,
  licenseCapacityStatus: PropTypes.object.isRequired,
};

export default CompanySearchBox;
